import { UseLocationModalResult, useLocationModal } from "../../hooks/useLocationModal.ts"

export function useMoneyflowVersionsModal(): UseLocationModalResult {
    return useLocationModal('moneyflow-versions')
}
